<template>
    <div >
        <Loading :value="loading"></Loading>

        <!-- MODAL AJOUT DE RESPONSABLE DE ZONE -->
        <v-dialog v-model="dialogAjoutResponsable" max-width="80%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span v-if="dialogEdit != true">Ajouter un responsable de zone</span>
                        <span v-if="dialogEdit">Modifier un responsable de zone  </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogAjoutResponsable = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <v-container fluid grid-list-md>
                        <v-form v-model="valid" ref="formUser" lazy-validation id="formUser">
                            <el-row :gutter="20">
                                <el-col :span="6">
                                    <div class="grid-content bg-purple">
                                        <el-card class="box-card" style="background:#fff">
                                            <div>
                                                <v-flex text-xs-center layout align-center justify-center>
                                                    <el-upload v-if="dialogEdit != true" class="upload-demo" list-type="picture-card" name="photo" action="" ref="upload" :auto-upload="false">
                                                        <i class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-upload v-if="dialogEdit" class="upload-demo" list-type="picture-card" name="photo" action="" ref="upload" :auto-upload="false">
                                                        <img height="142" width="142" v-if="responsable.urlImg" :src="responsable.urlImg" class="lazy" alt="">
                                                        <img height="142" width="142" v-else :src="logoUser" class="lazy" alt="">
                                                    </el-upload>
                                                </v-flex>
                                            </div>
                                        </el-card>
                                    </div>
                                </el-col>
                                <el-col :span="18" >
                                    <div class="grid-content" style="padding:3px">
                                        <el-row>
                                            <el-col>
                                                <div class="grid-content bg-purple">
                                                    <el-card class="box-card" style="background:#fff">
                                                        <v-layout row justify>
                                                            <v-flex md4>
                                                                <v-text-field label="Nom et prénoms" name="nomUser" v-model="responsable.nom" :rules="nomUserRules" :counter="4" required>
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex md4>
                                                                <v-text-field label="Login de connexion" name="loginUser" v-model="responsable.login" :rules="[(v) => !!v || 'Le login est obligatoire']" required>
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex md4>
                                                                <v-text-field label="E-mail" name="emailUser" v-model="responsable.email" :rules="loginUserRules" :counter="6" required>
                                                                </v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row justify>
                                                            <v-flex md4>
                                                                <v-text-field name="contactUser" min="0" label="Contact" v-model="responsable.contact" :counter="8" :rules="contactUserRules" hint="Exemple: 00-00-00-00" persistent-hint required></v-text-field>
                                                            </v-flex>
                                                            <v-flex md4>
                                                                <v-text-field label="Fonction occupée" name="fonctionUser" v-model="responsable.fonction" :counter="6" required></v-text-field>
                                                            </v-flex>
                                                            <v-flex md4>
                                                                <v-select label="Services" name="serviceUser" v-bind:items="listService" v-model="responsable.serviceId" :rules="serviceUserRules" item-value="id" item-text="libelle" ></v-select>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row justify>
                                                            <v-flex md4>
                                                                <v-select :disabled="dialogEdit" label="Type d'utilisateur" name="serviceUser" v-bind:items="typeUser" v-model="responsable.type" :rules="[(v) => !!v || 'Veuillez sélectionner le type.']" item-value="value" item-text="text" ></v-select>
                                                            </v-flex>

                                                        </v-layout>

                                                        <p align="center">
                                                            <v-chip text-color="white" label color="primary" style="width: 100%">
                                                                PARAMETRE DE CONNEXION
                                                            </v-chip>
                                                        </p>

                                                        <v-layout row justify>
                                                            <v-flex md4 v-if="dialogEdit != true">
                                                                <v-text-field type="password" name="mdpUser" label="Mot de passe" v-model="responsable.password" :rules="mdpUserRules" :counter="4" required></v-text-field>
                                                            </v-flex>

                                                            <v-flex md4 v-if="dialogEdit != true">
                                                                <v-text-field type="password" name="mdpVerUser" label="Confirmer le mot de passe" v-model="responsable.confirmePassword" :rules="mdpVerUserRules" :counter="4" required></v-text-field>
                                                            </v-flex>
                                                            <v-flex md4 v-if="dialogEdit">
                                                                <!-- <v-text-field type="password" name="mdpUserConnect" label="Votre mot de passe" v-model="mdpUserConnect" :rules="mdpUserConnectRules" :counter="4" required></v-text-field> -->
                                                                <v-text-field type="password" name="mdpUserConnect" label="Votre mot de passe" v-model="mdpUserConnect" :rules="mdpUserConnectRules" :counter="4" required></v-text-field>

                                                            </v-flex>
                                                        </v-layout>
                                                    </el-card>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <br/>
                                </el-col>
                            </el-row>
                            <v-spacer></v-spacer>
                            <v-btn @click="clear" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                            <v-btn icons color="blue" @click="submitUser" :disabled="!valid" >Ajouter <v-icon right>add</v-icon></v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
        <!-- MODAL AJOUT DE RESPONSABLE DE ZONE -->

           <!-- MODAL SUPPRESSION -->
    <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer cet enregistrement ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red" @click.stop="deleteUser" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


         <!-- MODAL AJOUT DES ROLES -->
    <v-dialog v-model="dialogRole" max-width="60%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="orange">
          <v-toolbar-title>
            <span>Ajouter des droits d'accès</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogRole = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip text-color="white" label color="orange" style="font-size:22px; width:100%">
                ATTRIBUER DES ROLES A L'UTILISATEUR
              </v-chip>
            </p>

            <v-form v-model="valid" ref="formRole" lazy-validation id="formRole">
              <v-layout row justify>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Accès au dasbord</span>
                    <el-select filterable multiple v-model="menuSele" placeholder="Catégorie" style="width: 100%">
                      <el-option v-for="item in menu" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Attribuer des roles</span>
                    <el-select filterable multiple v-model="role" placeholder="Catégorie" style="width: 100%">
                      <el-option v-for="item in roles" :key="item.id" :label="item.description" :value="item.id"></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-btn @click="dialogRole = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submitRole" v-if="menuSele.length !== 0" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-form>
          </v-container>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>



        <!-- MODAL ATTRIBUER UNE EQUIPE -->
        <v-dialog v-model="dialogAttribuerEquipe" max-width="80%" :overlay="true" scrollable persistent>
            <v-flex xs12>


            <v-card>
                <v-toolbar style="flex: 1 1 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span v-if="dialogEdit != true">Attribuer une equipe</span>
                        <!-- <span v-if="dialogEdit">Modifier un responsable de zone  </span> -->
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogAttribuerEquipe = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-form>
                    <v-container>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md3 style="flex: 1 1 auto;">
                                <v-text-field
                                    label="Nom"
                                    placeholder="Nom de l'équipe"
                                    solo
                                ></v-text-field>
                                </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>

                <el-row>
                    <!-- <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-transfer style="margin: 10px; flex: 1 1 auto;"
                                filterable

                                filter-placeholder="State Abbreviations"
                                v-model="value2"
                                :data="data2">
                            </el-transfer>
                        </div>
                    </el-col> -->

                    <el-col :span="12">
                        <div class="grid-content bg-purple-light" style="width:500px;">
                            <el-card class="box-card" style="margin: 10px;">
                                <div slot="header" class="clearfix" style=" display: table; content: ' '; clear: both; flex: 1 1 auto;">
                                    <span>Card name</span>
                                </div>
                                <div v-for="o in 5" :key="o" class="text item" style="margin-bottom: 18px; font-size: 14px; flex: 1 1 auto;">
                                    {{'La liste des elements ' + o }}
                                </div>
                            </el-card>
                        </div>
                    </el-col>
                </el-row>

                <hr style="height:10px; color:#c0eff8; border-radius:50px; flex: 1 1 auto;">

                <div class="text-xs-right">
                    <v-tooltip top>
                        <v-btn slot="activator"  icons @click="clear" color="orange" dark >Annuler<v-icon rigth>remove_circle</v-icon></v-btn>
                        <v-btn slot="activator" icons color="blue" @click.stop="" dark>Ajouter<v-icon rigth>add</v-icon></v-btn>
                    </v-tooltip>
                </div>

                <div style="flex: 1 1 auto;"></div>
             </v-card>
             </v-flex>
        </v-dialog>

        <!-- ATTRIBUER UNE  ZONE A UN RESPONSABLE -->
            <ModalAttribuerZone :userResponsable=responsable  :show = showModalZone @close="showModalZone = false" ></ModalAttribuerZone>
         <!-- ATTRIBUER UNE  ZONE A UN RESPONSABLE -->

       <!-- ATTRIBUER UNE  EQUIPE A UN RESPONSABLE -->
            <ModalAttribuerEquipe  :userResponsable=responsable :show = showModalEquipe @close="showModalEquipe = false" ></ModalAttribuerEquipe>

        <v-container>
            <!-- BTN AJOUT -->
                        <v-spacer></v-spacer>
                        <div v-if="droitAcces.create_user" class="text-xs-right">
                            <v-tooltip top>
                                <v-btn slot="activator" icons color="blue" @click.stop="showModalNewUser();" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                                Ajouter un nouveau responsable
                            </v-tooltip>
                        </div>
                <v-card>
                    <v-card-text>
                        <el-row>
                            <el-col :span="10">
                                <div class="grid-content bg-purple">
                             <!-- Titre -->
                            <v-chip text-color="white" label color="primary">
                                LISTE DES RESPONSABLES DE ZONES <v-icon right>accessibility</v-icon>
                            </v-chip>
                           </div>
                            </el-col>
                            <el-col :span="14">
                                <div class="grid-content bg-purple-light">
                                        <v-flex xs3 >
                                            <el-col :span="2" >
                                            <el-popover
                                            ref="popover5"
                                            placement="top"
                                            width="180"
                                            trigger="hover"
                                            >
                                                <p>Veuillez choisir le format d'impression ?</p>
                                                <div style="text-align: right; margin: 0">
                                                <el-button type="success" size="mini" @click="imprimeListeRespo('PDF')">PDF</el-button>
                                                <el-button type="primary" size="mini" @click="imprimeListeRespo('EXC')">EXCEL</el-button>
                                                </div>
                                            </el-popover>
                                                <div>
                                                <el-button v-popover:popover5 type="warning" :disabled="disabledBtnRespo"
                                                    icon="el-icon-printer" >Imprimer la liste
                                                </el-button>
                                                </div>
                                            </el-col>
                                        </v-flex>
                                </div>
                            </el-col>
                        </el-row>

                        <v-layout row>

                            <v-flex>
                                <data-tables :data="listeResponsable" >
                                    <el-table-column prop="avatar" label="Avatar"  fixed="left" > </el-table-column>
                                    <el-table-column prop="nom" label="Nom et prenoms" ></el-table-column>
                                    <el-table-column prop="login" label="Login" > </el-table-column>
                                    <el-table-column prop="contact" label="Contact" > </el-table-column>
                                    <el-table-column label="Action" align="center" fixed="right"  >
                                        <template slot-scope="scope">
                                            <v-tooltip top>
                                                <v-btn v-if="droitAcces.admin_profil_update_user" slot="activator" @click="showModalEditUser(scope.row)" fab dark small color="blue">
                                                    <v-icon dark>edit</v-icon>
                                                </v-btn>
                                                Editer
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <v-btn   slot="activator" fab small icons color="green" @click.native="modalZone(scope.row)" dark>
                                                    <v-icon center>home</v-icon>
                                                </v-btn>
                                                Attribuer une zone
                                            </v-tooltip>
                                             <v-tooltip top>
                                                <v-btn v-if="droitAcces.role_user" slot="activator" @click.stop="newRole(scope.row)" fab dark small color="orange">
                                                <v-icon dark>vpn_key</v-icon>
                                                </v-btn>
                                                Droit d'accès
                                            </v-tooltip>

                                                        <v-tooltip top>
                                                <v-btn v-if="droitAcces.user_delete" slot="activator" @click.stop="itemUser = scope.row;dialogSupr = true; " fab dark small color="red">
                                                <v-icon dark>delete</v-icon>
                                                </v-btn>
                                                Supprimer
                                            </v-tooltip>
                                        </template>
                                    </el-table-column>
                                </data-tables>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
        </v-container>

    </div>
</template>

<script>
    import Loading from '@/components/Loading'
     import ModalAttribuerZone from '@/components/user/ModalAttribuerZone'
     import ModalAttribuerEquipe from '@/components/user/ModalAttribuerEquipe'

    export default {
        components:{ Loading,ModalAttribuerZone,ModalAttribuerEquipe },
        name: "Responsable",
        data() {

            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,

                valid: true,
                 items: [
                { value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }
                ],
                mdpUserConnect: '',
                listService: [],
                dialogSupr: false,
                listeResponsable:[],
                dialogAjoutResponsable: false,
                dialogEdit: false,
                itemUser: null,
                disabledBtnZone: false,
                recherche: "",
                dialogAttribuerEquipe: false,
                disabledBtnTech: false,
                disabledBtnRespo: false,
                logoUser: "/static/avatar-conducteur.png",

                menuSele:[],
                 menu:[],
                  roles:[],
                responsable: {},
                selectTypeUser: null,
                selectServiceUser: null,
                dialogRole: false,
                 role:[],
                typeUser: [
                    { text: 'Responsable de zone', value: 4 }
                ],
                mdpUser: '',
                mdpVerUser: '',
                mdpUserConnect: '',
                serviceUserRules: [
                    (v) => !!v || 'Veuillez sélectionner votre service.',
                ],
                loginUserRules: [
                    (v) => !!v || 'Le E-mail est obligatoire',
                    (v) => /^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
                ],
                nomUserRules: [
                    (v) => !!v || 'Le nom est obligatoire',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                mdpUserRules: [
                    (v) => !!v || 'Le mot de passe est obligatoire',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                mdpVerUserRules: [
                    (v) => !!v || 'La verification du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                mdpUserConnectRules: [
                    (v) => !!v || 'Votre mot de passe est obligatoire pour la confirmation'
                ],
                contactUserRules: [
                    (v) => !!v || "Le contact de l'utilisateur est obligatoire",
                    (v) => /[0-9]/.test(v) || 'Vous devez respecter format du contact'
                ],

                //attribuer des zones
                showModalZone : false,

                //Attribuer une equipe
                showModalEquipe:false

            };
        },

        methods: {

        imprimeListeRespo(type){
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"userCreate/imprimerPDF/responsable/liste"
                }else {
                    url = this.domaine+"userCreate/imprimerEXC/responsable/liste"
            }
            window.open(url)
        },
            attribuerEquipe(){
                this.dialogAttribuerEquipe=true;
            },
            deleteUser () {

                console.log("item")
                console.log( this.itemUser)

        let url = this.domaine + 'userCreate/delete/' + this.itemUser.id
        this.loading = true;
        this.$http.get(url).then(response => {
            this.loading = false
          if (response.body) {
            if (response.body.code === 1) {
              this.$notify({
                title: 'SUPPRESSION',
                message: 'Utilisateur supprimé avec succès.',
                type: 'success',
                position: 'top-center'
              })
              this.dialogSupr = false

              this.loadResponsable ()
            } else {
              this.$notify.error({
                title: 'SUPPRESSION ECHOUE',
                message: 'La suppression du fournisseur a échoué.',
                position: 'top-center'
              })
            }
          }
        })
      },

            showModalNewUser(){
                this.dialogEdit = false
                this.dialogAjoutResponsable = true // afficher le modal ajout utilisateur
            },
            showModalEditUser(editResponsable){
                this.dialogEdit = true
                this.responsable = editResponsable
                this.dialogAjoutResponsable = true

            },
            clear () {
                this.$refs.formUser.reset()
                this.dialogAjout = false
            },

            loadResponsable () {
                let url = this.domaine + 'userCreate/index/zone/'+ this.user.id +'/responsable'
                if(this.droitAcces.index_user){
                  url = this.domaine + 'userCreate/index/zone/responsable'
                }
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listeResponsable = response.body
                        if (this.listeResponsable === undefined || this.listeResponsable.length == 0) {
                            this.disabledBtnZone = true
                        } else{

                        }
                    }
                })
            },

            submitUser()
            {

                if (this.$refs.formUser.validate())
                {
                    if (this.responsable.password === this.responsable.confirmePassword)
                    {
                        var form = document.getElementById('formUser')
                        var formdata = new FormData(form)
                        let url = ''
                        if (this.responsable.id) {
                            url = this.domaine + 'userCreate/'+ this.responsable.id +'/user/edit'
                            formdata.append('mdpUser',this.mdpUserConnect)
                        } else {
                            url = this.domaine + 'userCreate/new'
                            formdata.append('mdpUser',this.responsable.password)
                            formdata.append('mdpVerUser',this.responsable.confirmePassword)
                        }
                        formdata.append('idUser', this.user.id)
                        formdata.append('serviceUser', this.responsable.serviceId)
                        formdata.append('nomUser', this.responsable.nom)


                        formdata.append('loginUser', this.responsable.login)
                        formdata.append('emailUser', this.responsable.email)
                        formdata.append('contactUser', this.responsable.contact)
                        formdata.append('fonctionUser', this.responsable.fonction)
                        formdata.append('type', this.responsable.type)
                        formdata.append('poste', '')
                        formdata.append('roleUser', this.role)

                        this.loading = true
                        this.$http.post(url, formdata).then(response => {
                                this.loading = false
                                this.dialogAjoutResponsable = false
                                    let verif = response.body
                                    if (this.responsable.id) {
                                        if (verif.code === 1) {
                                            this.$notify({
                                                title: "L'UTILISATEUR A BIEN ETE MODIFIE",
                                                message: 'Modification effectué avec succès.',
                                                type: 'success',
                                                position: 'top-center'
                                            })

                                        } else if (verif.code === 2) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 3) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 4) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 5) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 0) {
                                            this.$message.error(verif.message)
                                        }
                                    } else {
                                        if (verif.code === 1) {
                                            this.$notify({
                                                title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                                                message: 'Enrégistrement réussie avec succès.',
                                                type: 'success',
                                                position: 'top-center'
                                            })

                                        } else if (verif.code === 2) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 3) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 4) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 5) {
                                            this.$message.error(verif.message)
                                        } else if (verif.code === 0) {
                                            this.$message.error(verif.message)
                                        }
                                    }
                                this.loadResponsable()
                            },
                            response => {
                                this.$message.error('Erreur serveur')
                                this.loading = false
                            })
                    } else {
                        this.$message.error('Le mot de passe de vérification doit être identique au mot de passe')
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "Utilisateur n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
             newRole (item) {
                this.responsable = item
                this.dialogRole = true
                this.role = item.roles
                this.menuSele = item.menus
            },
            loadService () {
                let url = this.domaine + 'webService/liste-service'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listService = response.body.service
                        this.menu = response.body.menu
                        this.roles = response.body.role
                    }
                })
            },

            //attribuer zone
              modalZone(editResponsable) {
                this.responsable = editResponsable
                this.showModalZone = true
            },
             newRole (item) {
                this.responsable = item
                this.dialogRole = true
                this.role = item.roles
                this.menuSele = item.menus
            },
            submitRole () {
        this.loading = true
        if (this.$refs.formRole.validate()) {
          var form = document.getElementById('formRole')
          var data = new FormData(form)
          let url = this.domaine + 'userCreate/'+ this.responsable.id +'/role/user'
          data.append('idUser', this.user.id)
          data.append('menuUser', this.menuSele)
          data.append('roleUser', this.role)

          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: 'Droits enrégistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
              }

              this.loading = false
              this.dialogRole = false

              this.loadResponsable()


              this.$refs.formRole.reset()
              let menu = verif.menu
              let droit = verif.role
              sessionStorage.setItem('sessionAcces', JSON.stringify(menu))
              sessionStorage.setItem('sessionDroit', JSON.stringify(droit))
              this.roleAcces = JSON.parse(sessionStorage.getItem('sessionAcces'))
              this.droitAcces = JSON.parse(sessionStorage.getItem('sessionDroit'))
            } else {
              this.$message.error('Erreur serveur')
              this.loading = false
              this.dialogRole = false
            }
          },
          response => {
            this.$message.error('Erreur serveur')
            this.loading = false
          })
        } else {
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Utilisateur n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
        },
         beforeMount: function () {
      if(!this.roleAcces[this.$router.history.current.name]){
        this.$router.push({ name: 'Home'  })
      }
    },
        mounted()
        {
            this.loadService()
            this.loadResponsable ()
        }
    }

    /*export default {
    data() {


    }
  };*/
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/Responsable.vue